import React, { useContext, useState, useRef, useMemo, useEffect } from "react";
import { IconButton, Table, TableHead, TableBody, TableRow, TableCell, Paper, Menu, MenuItem, TableSortLabel, Tooltip, ButtonGroup, Box, Typography, } from "@mui/material";
import useTradeCell from "../../tablecells/Trade";
import { ThemeContext } from "../../../context/ThemeContext";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import CheckIcon from "@mui/icons-material/Check"
import { useTranslation } from "react-i18next";
import { closeOrderPosition, } from "../../../api/request/dashboard/dashboard";
import '../../../App.scss'
import toast from 'react-hot-toast';
import Checkbox from '@mui/material/Checkbox';
import Order from './order/Orders'
import { deletePositionsData, setUpdateClmData } from "../../../store/Slices/orderPositionSlice";
import { getCookies } from "../../../services/Cookies";
import TradeMenu from "../../../MobileView/components/TradeMenu";
import EditPositionModal from "../../modal/EditSLTP/EditPositionModal";
import AccountFooter, { deletePLValue } from "../../footer/AccountFooter";
import FloatingProfitLoss from "../../global/BidAsk/FloatingProfitLoss";
import TotalCommission from "../../global/BidAsk/TotalCommission";
import { MdOutlineCancel } from "react-icons/md";
import { addJournalLog } from "./journal/addJournalLog";
import { updateProfitLoss } from "../../../store/Slices/profitLossSlice";
import { calculateCommission, calculateProfitLoss, getStopLoss, getTakeProfit } from "./netTrade/utils/tradeCalculation";


export default function Trade({ handleOpenModifyPositionModal, handleChartFromTradeTabClick }) {
  const { darkMode } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const [contextMenu, setContextMenu] = useState(null);
  const [submenuAnchor, setSubmenuAnchor] = useState(null);
  const { t } = useTranslation()
  const { accountId } = useSelector(state => state.accountSummary)
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'desc' });
  // const [showSearchBar, setShowSearchBar] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const positions = useSelector((state) => state.orderPosition.positions, shallowEqual);
  const { symbols } = useSelector(state => state.watchlist)
  const clientId = getCookies("clientId");
  const componentName = 'Trade'
  const storageKey = `hiddenColumns_${clientId}_${componentName}`;
  const [editSLTPData, setEditSLTPData] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false)
  const [closingIds, setClosingIds] = useState([]);
  const [activeRowId, setActiveRowId] = useState(null);
  const username = getCookies('username')
  const [selectedOrderRows, setSelectedOrderRows] = useState([]);
  const [visibleOrders, setVisibleOrders] = useState([]);
  const ordersRef = useRef();
  const symbolParam = useSelector(state => state.symbol.allSymbolParams, shallowEqual);

  const orderSLTP = useSelector(state => state.orderPosition.orderSLTP);

  const handleEditSLTP = (row) => {
    const filteredSLTPs = orderSLTP.filter(sltp => sltp.positionId === row.id);
    setEditModalOpen(true)
    setEditSLTPData(filteredSLTPs);

  };

  const handleCloseModal = () => {
    setEditModalOpen(false);
    setEditSLTPData(null);
  };

  const handleContextMenu = (event, row) => {
    event.preventDefault();
    setContextMenu({
      mouseX: event.clientX + 2,
      mouseY: event.clientY - 6,
      row,
    });
    console.log('row', row);

  };

  const handleCloseContextMenu = (event) => {
    // event.preventDefault();
    setContextMenu(null);
    setSubmenuAnchor(null);
  };

  const toggleColumnVisibility = (dataIndex) => {
    setVisibleColumns((prev) => {
      // const updatedColumns = { ...prev, [title]: !prev[title] };
      const updatedColumns = { ...prev, [dataIndex]: !prev[dataIndex] };
      const hiddenColumns = Object.keys(updatedColumns).filter(col => !updatedColumns[col]);
      localStorage.setItem(storageKey, JSON.stringify(hiddenColumns));
      dispatch(setUpdateClmData(Math.random()))
      return updatedColumns;
    });
    // setSubmenuAnchor(null);
    // setContextMenu(null)
  };

  const handleCloseClick = async (rowIndex = null, orderId = null) => {

    const ordersToClose = orderId
      ? [orderId]
      : rowIndex !== null
        ? [positions[rowIndex]?.id]
        : selectedRows;

    if (ordersToClose.length === 0) {
      toast.error("No trades selected");
      return;
    }

    setClosingIds(prev => [...new Set([...prev, ...ordersToClose])]);

    const closeRequests = ordersToClose.map(async (orderId) => {
      const selectedRow = positions.find(row => row.id === orderId);
      if (!selectedRow) return { success: false, positionId: orderId };

      const closeOrderPayload = {
        accountId: Number(accountId),
        positionId: selectedRow.id,
        amount: selectedRow.amount,
      };

      try {
        const response = await closeOrderPosition(closeOrderPayload);
        if (response.status === 200) {
          dispatch(deletePositionsData(orderId));
          addJournalLog('tradeClosed', `Trade closed: ID #${orderId}, ${selectedRow.symbolName}, at ${selectedRow.openPrice}, ${selectedRow.side === 1 ? "Buy" : "Sell"}, Amount: ${selectedRow.amount}, P/L: ${selectedRow.profitLoss}, Account ${username}: ${accountId}.`);
          return { success: true, positionId: orderId, position: selectedRow, message: response?.data?.message || "Unexpected server response", };
        }
      } catch (error) {
        let apiMessage = "Unknown error";

        if (error?.response?.data?.message) {
          apiMessage = error.response.data.message;
        } else if (error?.message) {
          apiMessage = error.message;
        }
        addJournalLog('closePositionError', `Close position: #${selectedRow.id} failure: ${selectedRow.error}, Account ${username}: ${accountId}.`);
        console.error("Error closing order:", error);
        return { success: false, positionId: orderId, position: selectedRow, message: apiMessage, };

      }
    });

    const results = await Promise.allSettled(closeRequests);

    results.forEach(({ status, value }) => {
      if (status === "fulfilled" && value?.success) {
        const { positionId, position } = value;
        if (position) {
          const { symbolId, symbolName, side, profitLoss } = position;
          const price = side === 1 ? symbols[symbolId]?.bid : symbols[symbolId]?.ask;
          const tradeSide = side === 1 ? "Buy" : "Sell";

          // toast.success(`Closed Trade #${positionId} (${symbolName}) at ${price}, ${tradeSide}, P/L ${profitLoss}`);
          deletePLValue(`${accountId}-${positionId}`);
          dispatch(updateProfitLoss());

        }

      } else {
        const { positionId, position, message } = value || {};
        if (position) {
          const { symbolId, symbolName, side } = position;
          const price = side === 1 ? symbols[symbolId]?.bid : symbols[symbolId]?.ask;

          toast.error(`Failed to close Trade #${positionId} (${symbolName}) at ${price} due to: ${message || 'unknown error'}`);

        }
      }
    });

    setSelectedRows([]);
    selectedRowsRef.current = [];
    setForceUpdate(prev => !prev);
    setClosingIds(prev => prev.filter(id => !ordersToClose.includes(id))); // cleanup
    handleCloseContextMenu();
  };

  const TradeCell = useTradeCell(handleEditSLTP, handleContextMenu, handleCloseClick, closingIds)

  const getInitialVisibleColumns = () => {
    const storedHiddenColumns = JSON.parse(localStorage.getItem(storageKey));
    if (storedHiddenColumns) {
      return TradeCell.reduce((acc, col) => ({
        ...acc,
        [col.dataIndex]: !storedHiddenColumns.includes(col.dataIndex)

      }), {});
    }
    return TradeCell.reduce((acc, col) => ({ ...acc, [col.dataIndex]: true }), {});
  };
  const [visibleColumns, setVisibleColumns] = useState(getInitialVisibleColumns);

  const resetAllColumns = () => {
    const resetColumns = TradeCell.reduce((acc, col) => ({ ...acc, [col.dataIndex]: true }), {});
    setVisibleColumns(resetColumns);
    localStorage.removeItem(storageKey);
    setSubmenuAnchor(null);
    setContextMenu(null)
  }
  const enrichedPositions = useMemo(() => {
    return positions.map((pos) => {
      const symbol = symbols?.[pos.symbolId];
      const refSymbol = symbols?.[symbol?.referenceSymbolId];
      const symbolData = symbolParam?.[pos.symbolId]
      return {
        ...pos,
        profit: calculateProfitLoss({ row: pos, symbol, refSymbol, symbolData }),
        commission: calculateCommission({ row: pos, symbol, refSymbol, symbolData }),
        stopLoss: getStopLoss(orderSLTP, pos.id, symbol?.digits) ?? null,
        takeProfit: getTakeProfit(orderSLTP, pos.id, symbol?.digits) ?? null,

      };
    });
  }, [positions, symbols, symbolParam, orderSLTP]);
  const initialSorted = useMemo(() => {
    if (!Array.isArray(enrichedPositions)) return [];

    return [...enrichedPositions].sort((a, b) => {
      const dateA = new Date(a.dateTime);
      const dateB = new Date(b.dateTime);
      return dateB - dateA; // Newest first
    });
  }, [enrichedPositions]);

  const sortTradeData = useMemo(() => {
    if (!Array.isArray(initialSorted)) return [];

    return [...initialSorted].sort((a, b) => {
      if (!sortConfig.key) return 0;
      const valueA = a[sortConfig.key];
      const valueB = b[sortConfig.key];
      const key = sortConfig.key;
      const dir = sortConfig.direction === 'asc' ? 1 : -1;
      if (key === 'dateTime') {
        const dateA = new Date(valueA);
        const dateB = new Date(valueB);
        return (dateA - dateB) * dir;
      }
      if (typeof valueA === 'number' && typeof valueB === 'number') {
        return sortConfig.direction === 'asc' ? valueA - valueB : valueB - valueA;
      }
      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return sortConfig.direction === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      }
      return 0;
    });
  }, [initialSorted, sortConfig]);


  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const filteredData = useMemo(() => {
    return sortTradeData.filter((row) =>
      TradeCell.some((col) => row[col.dataIndex]?.toString().toLowerCase().includes(searchQuery.toLowerCase()))
    );
  }, [sortTradeData, searchQuery]);

  const [selectedRows, setSelectedRows] = useState([]);
  const allSelected = selectedRows.length === filteredData.length && filteredData.length > 0;

  const handleRowSelect = (rowId) => {
    setSelectedRows((prev) => {
      const updated = prev.includes(rowId)
        ? prev.filter(id => id !== rowId)
        : [...prev, rowId];

      selectedRowsRef.current = updated;
      return updated;
    });
  };

  const handleSelectAll = () => {
    const newSelected = allSelected ? [] : [...filteredData.map(row => row.id)];
    setSelectedRows([...newSelected]);
  };

  const selectedRowsRef = useRef(new Set());
  const [forceUpdate, setForceUpdate] = useState(false);
  const totalInterest = filteredData.reduce((sum, item) => sum + (parseFloat(item.interest) || 0), 0);

  const totalAmount = filteredData.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
  const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);


  const fixedHeaderContent = () => {
    return <TableRow sx={{ borderTop: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, }} >
      <TableCell padding="checkbox" sx={{ position: "sticky", top: 0, zIndex: 2, borderBottom: "1px solid rgba(224, 224, 224, 0.3)", padding: "5px 5px", backgroundColor: darkMode ? "#151924" : "#fff", fontWeight: 700 }}>
        <ButtonGroup variant="outlined" sx={{ display: "flex", alignItems: "center", gap: 1, border: 'none' }}>
          <Tooltip title={t('selectall')}>
            <Checkbox checked={allSelected} onChange={handleSelectAll} indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length} sx={{ width: 24, height: 24, "& .MuiSvgIcon-root": { fontSize: 14 } }} />
          </Tooltip>
          <Tooltip title={t('delete')}>
            <span>
              <IconButton disabled={selectedRows.length === 0} onClick={() => handleCloseClick(null, selectedRows.id)} sx={{ color: "red", }}><MdOutlineCancel style={{ fontSize: '15px' }} /></IconButton>
            </span>
          </Tooltip>
        </ButtonGroup>
      </TableCell>
      {TradeCell.map(
        (col, index) => visibleColumns[col.dataIndex] && (
          <TableCell style={{ position: "sticky", top: 0, zIndex: 2, width: col?.width, fontWeight: 550, textTransform: "capitalize" }} key={index} sx={{ fontSize: "0.85rem", fontWeight: 200, p: 1, backgroundColor: darkMode ? "var(--background-color)" : "var(--white)", cursor: col.dataIndex !== t('actions') ? "pointer" : "default", borderBottom: "1px solid rgba(224, 224, 224, 0.3)", borderRight: `1px solid ${darkMode ? "#444" : "var(--borderLight)"}`, }} onClick={() => col.dataIndex !== t('actions') && handleSort(col.dataIndex)}>
            <TableSortLabel active={sortConfig.key === col.dataIndex} direction={sortConfig.direction}>
              {col.title}
            </TableSortLabel>
          </TableCell>
        )
      )}
    </TableRow>
  }

  return (
    <>
      <>
        <Paper style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
          <Box sx={{ flex: 1, overflow: "auto", height: "calc(100% - 35px)", backgroundColor: darkMode ? "#151924" : "#fff" }}>
            <Box sx={{ backgroundColor: darkMode ? "#151924" : "#fff" }}>
              <Table sx={{ borderCollapse: "separate" }}>
                <TableHead>{fixedHeaderContent()}</TableHead>
                <TableBody>
                  {filteredData.length > 0 && filteredData.map((row, index) => (
                    <TableRow key={row.id} onClick={(e) => {
                      if (
                        e.target.closest('button') ||
                        e.target.closest('input[type="checkbox"]')
                      ) return;
                      setActiveRowId(row.id);
                    }}
                      onContextMenu={(event) => {
                        event.preventDefault();
                        handleContextMenu(event, row);
                        setActiveRowId(row.id);
                      }}
                      sx={{ '& .tradeRow': { backgroundColor: activeRowId === row.id ? (darkMode ? 'var(--highlightDark)' : 'var(--highlightLight)') : 'inherit', }, '&:hover .tradeRow': { backgroundColor: darkMode ? '#1f2635' : '#f5f5f5', }, }}>
                      <TableCell className="tradeRow" padding="checkbox" sx={{ border: 'none', padding: "5px", }}>
                        <Checkbox checked={selectedRows.includes(row.id)} onChange={() => handleRowSelect(row.id)} sx={{ width: 24, height: 24, "& .MuiSvgIcon-root": { fontSize: 12 } }} />
                      </TableCell>

                      {TradeCell.filter(col => visibleColumns[col.dataIndex]).map((col, colIndex) => (
                        <TableCell className="tradeRow" key={`${row.id}-${colIndex}`} selected={selectedRows.includes(row.id)} sx={{ fontSize: "0.8rem", border: 'none', padding: "5px 5px" }}>
                          {col.render(row[col.dataIndex], row)}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}

                  <TableRow sx={{ backgroundColor: darkMode ? "#2b3543" : "var(--secondaryLight)" }}>
                    {/* <TableCell sx={{ border: "none", padding: "5px 5px", backgroundColor: darkMode ? "#2b3543" : "var(--secondaryLight)" }} /> */}
                    <TableCell padding="checkbox" sx={{ border: 'none', padding: "5px" }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'flex-start' }}>
                        <Tooltip title={t('selectall')}>
                          <Checkbox sx={{ width: 24, height: 24, "& .MuiSvgIcon-root": { fontSize: 15 } }} checked={visibleOrders.length > 0 && selectedOrderRows.length === visibleOrders.length}
                            indeterminate={selectedOrderRows.length > 0 && selectedOrderRows.length < visibleOrders.length}
                            onChange={(e) => {
                              if (e.target.checked) {
                                const allIds = visibleOrders.map((row) => row.id);
                                setSelectedOrderRows(allIds);
                              } else {
                                setSelectedOrderRows([]);
                              }
                            }}
                          />
                        </Tooltip>
                        <Tooltip title={t('cancelSelected')}>
                          <IconButton size="small" onClick={async () => {
                            if (ordersRef.current?.closeOrderById) {
                              for (let rowId of selectedOrderRows) {
                                await ordersRef.current.closeOrderById(rowId);
                              }
                              setSelectedOrderRows([]);
                            }
                          }} >
                            <MdOutlineCancel style={{ fontSize: 14, color: selectedOrderRows.length > 0 ? 'red' : 'gray', opacity: selectedOrderRows.length > 0 ? 1 : 0.4, transition: 'all 0.3s ease-in-out', cursor: selectedOrderRows.length > 0 ? 'pointer' : 'default', }} />
                          </IconButton>
                        </Tooltip>
                      </Box>

                    </TableCell>
                    {TradeCell.filter(col => visibleColumns[col.dataIndex]).map((col, colIndex) => {
                      const commonStyle = { padding: "5px 5px", fontWeight: 'bold', fontSize: '0.8rem', backgroundColor: darkMode ? "#2b3543" : "var(--secondaryLight)", color: darkMode ? 'var(--white)' : "var(--black)" };

                      switch (col.dataIndex) {
                        case "amount":
                          return (<TableCell key="total-amount" sx={commonStyle}>{totalAmount.toFixed(decimalPlaces)}</TableCell>);
                        case "commission":
                          return (<TableCell key="total-commission" sx={commonStyle}><TotalCommission /></TableCell>);
                        case "interest":
                          return (<TableCell key="total-interest" sx={commonStyle}>{totalInterest.toFixed(2)}</TableCell>);
                        case "profit":
                          return (<TableCell key="total-profit" sx={commonStyle}><FloatingProfitLoss /></TableCell>);
                        default:
                          if (colIndex === 0) {
                            return (
                              <TableCell sx={commonStyle}><Typography sx={{ padding: "5px 5px", whiteSpace: "nowrap", fontWeight: 'bold', fontSize: '0.8rem', backgroundColor: darkMode ? "#2b3543" : "var(--secondaryLight)", color: darkMode ? 'var(--white)' : "var(--black)" }}>{t('pendingOrders')}</Typography></TableCell>

                            );
                          }
                          // if (colIndex === 1) return null;
                          return (<TableCell key={`empty-${colIndex}`} sx={commonStyle} />);
                      }
                    })}
                  </TableRow>
                </TableBody>
                <Order ref={ordersRef} sortConfig={sortConfig} searchQuery={searchQuery} selectedRows={selectedOrderRows} setSelectedRows={setSelectedOrderRows} setVisibleOrders={setVisibleOrders} />
              </Table>
            </Box>
          </Box>
          <Box sx={{ height: 35, position: "relative", zIndex: 99, backgroundColor: darkMode ? "#151924" : "#fff", borderTop: "1px solid rgba(0, 0, 0, 0.3)", }}>
            <AccountFooter searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
          </Box>
        </Paper>
      </>


      <Menu sx={{ "& .MuiList-root": { padding: 0 } }} open={contextMenu !== null} onClose={handleCloseContextMenu} anchorReference="anchorPosition" anchorPosition={contextMenu ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}>
        <TradeMenu handleOpenModifyPositionModal={handleOpenModifyPositionModal} handleChartFromTradeTabClick={handleChartFromTradeTabClick} contextMenu={contextMenu} setContextMenu={setContextMenu} style={{ fontSize: 13.5 }} showColumnsMenu={true} setSubmenuAnchor={setSubmenuAnchor} />
      </Menu>

      <Menu sx={{ "& .MuiList-root": { padding: 0 } }} open={Boolean(submenuAnchor)} anchorEl={submenuAnchor} onClose={handleCloseContextMenu} anchorOrigin={{ vertical: "top", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "left" }}>
        <div style={{ backgroundColor: darkMode ? "#262f3f" : "" }}>
          {TradeCell.filter(col => col.title !== `${t('symbol')}` && col.title !== `${t('P/L')}`).map((col, index) => (
            <MenuItem key={index} onClick={() => toggleColumnVisibility(col.dataIndex)} sx={{ fontSize: 13.5, display: "flex", justifyContent: "space-between", alignItems: "center", }}>
              {col.title} {visibleColumns[col.dataIndex] && (<CheckIcon sx={{ fontSize: 18, color: "#4597ff", }} />)}
            </MenuItem>))}

          <MenuItem onClick={resetAllColumns} sx={{ fontSize: 13.5, display: "flex", justifyContent: "space-between", alignItems: "center", borderTop: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}` }}>{t('resetAll')}</MenuItem>
        </div>
      </Menu>
      {editModalOpen && (<EditPositionModal open={editModalOpen} handleClose={handleCloseModal} editSLTP={editSLTPData} />)}
    </>
  );
} 